import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';
import { Button, IconButton, PanelBody, Toolbar } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { withSelect } from '@wordpress/data';
import { BlockControls, InspectorControls } from '@wordpress/block-editor';
import ServerSideRender from '@wordpress/server-side-render';
/**
 * Internal dependencies
 */

import LegacyWidgetEditHandler from './handler';
import LegacyWidgetPlaceholder from './placeholder';

var LegacyWidgetEdit =
/*#__PURE__*/
function (_Component) {
  _inherits(LegacyWidgetEdit, _Component);

  function LegacyWidgetEdit() {
    var _this;

    _classCallCheck(this, LegacyWidgetEdit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LegacyWidgetEdit).apply(this, arguments));
    _this.state = {
      isPreview: false
    };
    _this.switchToEdit = _this.switchToEdit.bind(_assertThisInitialized(_this));
    _this.switchToPreview = _this.switchToPreview.bind(_assertThisInitialized(_this));
    _this.changeWidget = _this.changeWidget.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LegacyWidgetEdit, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          attributes = _this$props.attributes,
          availableLegacyWidgets = _this$props.availableLegacyWidgets,
          hasPermissionsToManageWidgets = _this$props.hasPermissionsToManageWidgets,
          setAttributes = _this$props.setAttributes;
      var isPreview = this.state.isPreview;
      var identifier = attributes.identifier,
          isCallbackWidget = attributes.isCallbackWidget;
      var widgetObject = identifier && availableLegacyWidgets[identifier];

      if (!widgetObject) {
        return createElement(LegacyWidgetPlaceholder, {
          availableLegacyWidgets: availableLegacyWidgets,
          currentWidget: identifier,
          hasPermissionsToManageWidgets: hasPermissionsToManageWidgets,
          onChangeWidget: function onChangeWidget(newWidget) {
            return setAttributes({
              instance: {},
              identifier: newWidget,
              isCallbackWidget: availableLegacyWidgets[newWidget].isCallbackWidget
            });
          }
        });
      }

      var inspectorControls = createElement(InspectorControls, null, createElement(PanelBody, {
        title: widgetObject.name
      }, widgetObject.description));

      if (!hasPermissionsToManageWidgets) {
        return createElement(Fragment, null, inspectorControls, this.renderWidgetPreview());
      }

      return createElement(Fragment, null, createElement(BlockControls, null, createElement(Toolbar, null, !widgetObject.isHidden && createElement(IconButton, {
        onClick: this.changeWidget,
        label: __('Change widget'),
        icon: "update"
      }), !isCallbackWidget && createElement(Fragment, null, createElement(Button, {
        className: "components-tab-button ".concat(!isPreview ? 'is-active' : ''),
        onClick: this.switchToEdit
      }, createElement("span", null, __('Edit'))), createElement(Button, {
        className: "components-tab-button ".concat(isPreview ? 'is-active' : ''),
        onClick: this.switchToPreview
      }, createElement("span", null, __('Preview')))))), inspectorControls, !isCallbackWidget && createElement(LegacyWidgetEditHandler, {
        isVisible: !isPreview,
        identifier: attributes.identifier,
        instance: attributes.instance,
        onInstanceChange: function onInstanceChange(newInstance) {
          _this2.props.setAttributes({
            instance: newInstance
          });
        }
      }), (isPreview || isCallbackWidget) && this.renderWidgetPreview());
    }
  }, {
    key: "changeWidget",
    value: function changeWidget() {
      this.switchToEdit();
      this.props.setAttributes({
        instance: {},
        identifier: undefined
      });
    }
  }, {
    key: "switchToEdit",
    value: function switchToEdit() {
      this.setState({
        isPreview: false
      });
    }
  }, {
    key: "switchToPreview",
    value: function switchToPreview() {
      this.setState({
        isPreview: true
      });
    }
  }, {
    key: "renderWidgetPreview",
    value: function renderWidgetPreview() {
      var attributes = this.props.attributes;
      return createElement(ServerSideRender, {
        className: "wp-block-legacy-widget__preview",
        block: "core/legacy-widget",
        attributes: attributes
      });
    }
  }]);

  return LegacyWidgetEdit;
}(Component);

export default withSelect(function (select) {
  var editorSettings = select('core/block-editor').getSettings();
  var availableLegacyWidgets = editorSettings.availableLegacyWidgets,
      hasPermissionsToManageWidgets = editorSettings.hasPermissionsToManageWidgets;
  return {
    hasPermissionsToManageWidgets: hasPermissionsToManageWidgets,
    availableLegacyWidgets: availableLegacyWidgets
  };
})(LegacyWidgetEdit);
//# sourceMappingURL=index.js.map